/* eslint-disable no-multi-assign -- allowing no-multi-assign */
// /* eslint-disable prefer-destructuring -- allowing non destructuring */
/* eslint-disable no-underscore-dangle -- allowing no-underscore-dangle */
/* eslint-disable react/boolean-prop-naming -- allowing boolean-prop-naming */
import {
  ButtonPrimary, ButtonSecondary,
} from '@americanexpress/dls-react';
import { fetchWithReporter, reportError } from '@americanexpress/one-identity-ducks';
import { getRegionFromLocale } from '@americanexpress/one-identity-ducks/lib/utils';
import { queryProcedureResult } from 'iguazu-rpc';
import isMobile from 'is-mobile';
import noop from 'lodash/noop';
import {
  arrayOf,
  bool,
  func, node,
  number, oneOf,
  shape,
  string,
} from 'prop-types';
import React, { Component } from 'react';
import generateUUID from 'uuid/v4';
import { eventDelegator, unloadHandler } from '../framedLoginUtils';
import { onLoginSuccess } from '../login';
import {
  AEXP_CROSS_BORDER_PAYMENTS,
  CONTENT_TYPE,
  CONTENT_TYPE_JSON,
  EVENT_ARRAY_FAILURE_LOG,
  EVENT_ARRAY_LOG,
  LOGIN_CLICK,
  LOGIN_EVENT_FAILURE,
  LOGIN_INVOCATION,
  LOGIN_RESPONSE_LGON001,
  LOGIN_RESPONSE_LGON003,
  LOGIN_RESPONSE_LGON004,
  LOGIN_RESPONSE_LGON005,
  LOGIN_RESPONSE_LGON006,
  LOGIN_RESPONSE_LGON007,
  LOGIN_RESPONSE_LGON008,
  LOGIN_RESPONSE_LGON009,
  LOGIN_RESPONSE_LGON010,
  LOGIN_RESPONSE_LGON011,
  LOGIN_RESPONSE_LGON012,
  LOGIN_RESPONSE_LGON013,
  LOGIN_RESPONSE_LGON014,
  LOGIN_RESPONSE_LGON015,
  LOGIN_RESPONSE_LGON016,
  LOGIN_RESPONSE_LGON017,
  LOGIN_RESPONSE_LGON018,
  LOGIN_RESPONSE_LGON020,
  LOGIN_RESPONSE_RECEIVED,
  LOGIN_RESPONSE_SUCCESS,
  PARAM_CORRELATION_ID,
  ROUTE_TO_DESTINATION,
  STEP_ENTER_PASSWORD,
  STEP_ENTER_USERNAME,
  MESSAGE_POSITIVE,
  MESSAGE_WARNING,
  TYPE_MUTLIPAGE,
  MIGRATION_TYPE_MERCHANT,
  MIGRATION_TYPE_ATWORK,
} from '../scripts/constants';
import {
  destinationUrl,
  getLocaleFromCookie,
  qualifyUrl,
  shouldPasswordMigrate,
  verifyEncodedUrl,
  setLocalStorageCookie,
  getEidParam,
  getUserProducts,
  shouldRedirectToInstantProfile,
} from '../utils';
import LoginLinks from './LoginLinks';
import LoginMessage from './LoginMessage';
import MenuDropDown from './MenuDropDown';
import MultiPageGreeting from './MultiPageGreeting';
import PasswordInputWrapper from './PasswordInput';
import Recaptcha from './Recaptcha';
import RememberMe from './RememberMe';
import UserIdInput from './UserIdInput';

export const AUTH_READY_TIMEOUT = 2e3; // wait 2 seconds for inAuth

const PARAM_CREDENTIALS = 'credentials';
const PARAM_BODY = 'body';
const PARAM_METHOD = 'method';
const CREDENTIALS_INCLUDE = 'include';
const METHOD_POST = 'POST';
const TEMPLATES_IN_USE = ['light', 'compact', 'blue', 'enterprise']; // use current templates to dynamically create logs
let eventArray = [];
let loginStartTime;

const localeRedirectMap = {
  'th-th': 'en-gb',
  'en-th': 'en-gb',
  'de-ch': 'de-de',
  'fr-ch': 'fr-fr',
};

class LoginUI extends Component {
  constructor(props) {
    super(props);
    this.submitButtonRef = React.createRef();

    this.state = {
      password: props.password || '',
      remember: false,
      userId: '',
      uuid: generateUUID(),
      missing: false,
      disableSubmit: false,
      authReady: false,
      submitReady: false,
      framed: false,
      maskedName: '',
      hideMultiPageUserId: false,
      hideMultiPagePassword: true,
      step: STEP_ENTER_USERNAME,
      rockstarModal: false,
      showRecaptchaError: false,
      passwordAttempt: 0,
      wasFirstAttemptLowerCase: null,
      dropMenuKey: null,
      message: null,
      flattenedPassword: false,
      migrationType: null,
    };
    this.loadThirdPartyScripts = this.loadThirdPartyScripts.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated -- allowing no-deprecated
  componentWillMount() {
    const {
      query,
      hideLoginLogoutButton,
      clearStatus,
    } = this.props;
    clearStatus();
    hideLoginLogoutButton();
    this.updateDestination();
    this.setState({
      destPageParam: !!(query.destpage || query.target),
    });
    sessionStorage.removeItem('eidParam');
    if (global.BROWSER && !this.channel) {
      // eslint-disable-next-line global-require -- allowing global-require
      const MobileDetect = require('mobile-detect');
      const md = new MobileDetect(window.navigator.userAgent);

      this.channel = md.mobile() ? 'Mobile' : 'Web';
    }
  }

  componentDidMount() {
    const {
      shouldFocus,
      userId,
      setLocation,
      setContext,
      query,
    } = this.props;

    setLocation();
    setContext(query.context);
    this.updateDestination();
    this.loadThirdPartyScripts();

    setTimeout(() => {
      if (userId && this.inputUser) {
        this.inputUser.value = userId;
      }
      if (shouldFocus) {
        const focusElement = userId ? this.inputPassword : this.inputUser;
        if (focusElement) {
          focusElement.focus();
        }
      }
    }, 250);

    // It's OK to set state here. SSR will render the button in a disabled state
    // it should only be enabled when the component has mounted on the client,
    // otherwise the form action may not be set when user submits.
    // if the current window is not equal to the window.top, you are in an Iframe
    if (window && window !== window.top) {
      eventDelegator(document);
      document.addEventListener('beforeunload', unloadHandler);
      this.setState({
        framed: true,
      });
    }

    if (window && window.AmexSession) {
      window.AmexSession.clearSessionManagement();
    }

    this.setState({
      disableSubmit: false,
    });
  }

  // eslint-disable-next-line react/no-deprecated -- allowing no-deprecated
  componentWillReceiveProps(nextProps) {
    const {
      changeDestination,
      hideMenu,
      destPage,
    } = this.props;
    if (nextProps.destPage !== destPage
      || nextProps.hideMenu !== hideMenu) {
      const destination = this.getDestination(nextProps);
      changeDestination(destination);
    }
  }

  componentWillUnmount() {
    const { showLoginLogoutButton } = this.props;
    showLoginLogoutButton();
  }

  onFailure = (response, url, startTime) => {
    const { failureCodes, onFailure } = this.props;
    const { errorCode } = response;

    if (onFailure && (failureCodes === null || failureCodes.indexOf(errorCode) >= 0)) {
      onFailure(response, url);
    } else {
      this.internalErrorHandler(response, url, startTime);
    }
  };

  // eslint-disable-next-line no-promise-executor-return -- allowing no-promise-executor-return
  setStateSync = (state) => new Promise((resolve) => this.setState(state, resolve));

  stepper = (id) => {
    const { step } = this.state;
    const {
      faasApiUrl,
      getUserNameByUserId,
    } = this.props;
    if (step === STEP_ENTER_USERNAME) {
      if (!this.isAtWork() && !this.isMerchant()) {
        return getUserNameByUserId({ id, url: faasApiUrl }).then((name) => {
          this.setState({
            hideMultiPageUserId: true,
            hideMultiPagePassword: false,
            step: STEP_ENTER_PASSWORD,
          });
          return name;
        });
      }
    }
    this.setState({
      hideMultiPageUserId: true,
      hideMultiPagePassword: false,
      step: STEP_ENTER_PASSWORD,
      dropMenuKey: this.dropMenu && this.getSelectedMenuItem(),
    });
    return false;
  };

  loginFlowDecider = async (e) => {
    loginStartTime = Date.now();
    const date = new Date();
    eventArray.push({ eventType: LOGIN_CLICK, timestamp: date.toUTCString() });
    if (e) {
      e.preventDefault();
    }
    const { type } = this.props;
    const { step } = this.state;
    let maskedName;
    let userId;

    // Initially and after resubmit let's clear existing message
    // accessibility needs to read again every new or the same message
    this.setState({
      missing: false,
      message: null,
    });

    // The below if statement code is Mexico specific  - LGON16
    if (type === TYPE_MUTLIPAGE && step === STEP_ENTER_USERNAME) {
      userId = this.getUserId();
      if (userId) {
        await this.setStateSync({
          submitReady: true,
        });
        maskedName = await this.stepper(userId);
        await this.setStateSync({
          maskedName,
          userId,
          submitReady: false,
        });
        this.inputPassword.focus();
      }
      return false;
    }

    // The below if statement code is Mexico specific  - LGON16
    if (step === STEP_ENTER_PASSWORD) {
      await this.setStateSync({
        password: this.getPassword(),
      });
    }

    return this.submitLogin();
  }

  submitLogin = async () => {
    await this.setStateSync({
      submitReady: true,
      loading: true,
    });
    if (this.submitButtonRef.current) {
      this.submitButtonRef.current.focus();
    }
    return this.submitCheck();
  }

  submitCheck = () => {
    const { authReady, submitReady } = this.state;
    if (authReady && submitReady) {
      return this.onLogin();
    }
    return false;
  }

  onLogin = () => {
    const { type } = this.props;
    const { userId, password } = this.state;

    if ((this.getUserId() === '' || this.getPassword() === '') && (type !== TYPE_MUTLIPAGE)) {
      this.setState({
        missing: true,
        submitReady: false,
        loading: false,
      });
      this.userMessage();
      return false;
    }

    if ((userId === '' || password === '') && (type === TYPE_MUTLIPAGE)) {
      this.setState({
        missing: true,
        submitReady: false,
        loading: false,
      });
      this.userMessage();
      return false;
    }

    this.setState({
      missing: false,
    });

    // dispatch based on state.destination
    const { destinationFromState } = this.props;
    if (destinationFromState.sso) {
      this.ssoLogin();
    } else {
      this.mycaLogin();
    }
    return true;
  };

  // eslint-disable-next-line prefer-regex-literals -- allowing next-line prefer-regex
  getUserId = () => (this.inputUser ? this.inputUser.value?.replace(new RegExp('\u2022', 'g'), '*') : '');

  getPassword = () => (this.inputPassword ? this.inputPassword.value : '');

  // default destination (/dashboard) will be used
  getDestination = (props) => {
    const { dropMenuKey } = this.state;
    const {
      destPage,
      query,
      sso,
      brandname,
      overrideKey,
      defaultDestination,
    } = props;
    // if DestPage search param is provided, it will be returned
    const destUrl = query.destpage || query.target;
    if (destUrl) {
      return {
        url: verifyEncodedUrl(destUrl),
        sso: query.sso,
        brandname: query.brandname,
        overrideKey: query.option ?? query.overridekey ?? overrideKey ?? 'account',
      };
    }

    // if destPage property is provided, it will be returned
    // DEPRECATED, remove in v6
    if (destPage) {
      return {
        url: verifyEncodedUrl(destPage),
        sso,
        brandname,
        overrideKey,
      };
    }

    // if menu is shown, the menu selection will be returned
    if (this.dropMenu) {
      return this.getSelectedMenuItem();
    }

    if (dropMenuKey) {
      return dropMenuKey;
    }

    // return default destination, if available
    return {
      url: defaultDestination,
      overrideKey: overrideKey ?? 'account',
    };
  };

  getSelectedMenuItem = () => {
    const { menu } = this.props;
    const key = this.dropMenu.value;
    return menu.filter((item) => item.key === key)[0] ?? null;
  };

  getLinkByKey = (links, key) => links.filter((link) => link.key === key)[0] ?? null

  getNativeLink = (key) => {
    const { languageData: { links: { secondary } } } = this.props;
    return this.getLinkByKey(secondary, key);
  }

  getFuidLink = () => {
    const { effectiveKey } = this.props;
    const link = this.getNativeLink('forgotuserid');
    return link.url[effectiveKey] || link.url;
  }

  failureRevoked = (url, errorCode) => {
    const { setAppLocation, dispatch } = this.props;
    let redirectLink = this.getFuidLink();
    eventArray.push({
      eventType: LOGIN_EVENT_FAILURE,
      errorCode,
      timestamp: Date.now() - loginStartTime,
    });
    dispatch(reportError(new Error(EVENT_ARRAY_FAILURE_LOG), {
      collectionMethod: 'failureRevoked',
      moduleID: 'one-identity-login',
      errorCode,
      eventArray,
    }));
    eventArray = [];
    let source = url;
    if (redirectLink.startsWith('http')) { // if it is a legacy FUID link
      // qualify the DestPage link
      source = encodeURIComponent(qualifyUrl(decodeURIComponent(source)));
      redirectLink = redirectLink
        .replace('{dest}', source);
      window.location.assign(redirectLink);
    } else {
      // it is POA FUID
      redirectLink = `${redirectLink}?locked=true`;
      setAppLocation(redirectLink);
    }
  };

  failureLegacyReAuth = (redirectUrl, url, errorCode) => {
    const { setAppLocation, dispatch } = this.props;
    eventArray.push({
      eventType: LOGIN_EVENT_FAILURE,
      errorCode,
      timestamp: Date.now() - loginStartTime,
    });
    dispatch(reportError(new Error(EVENT_ARRAY_FAILURE_LOG), {
      collectionMethod: 'failureRevoked',
      moduleID: 'one-identity-login',
      errorCode,
      eventArray,
    }));
    eventArray = [];
    let destPage = redirectUrl;
    const destPt = destPage.indexOf('DestPage');
    const prefix = destPage.includes('?') ? '&' : '?';
    if (destPt !== -1) {
      destPage = destPage.slice(0, destPt);
      destPage = `${destPage}DestPage=${destinationUrl(url)}`;
    } else {
      destPage = `${destPage}${prefix}DestPage=${destinationUrl(url)}`;
    }
    setAppLocation(destPage);
  };

  failureReLogin = (url) => {
    const { remember, uuid } = this.state;
    const { legacyLogin } = this.props;
    const dest = qualifyUrl(decodeURIComponent(url));
    legacyLogin(
      this.getUserId(),
      this.getPassword(),
      remember,
      uuid,
      dest);
  };

  // For MFA journey
  failureReAuth = (response, cookieLocale) => {
    const {
      pathname,
      search,
      updateAuth,
      destinationFromState,
      noOp,
      query: { dispatch },
      languageData: {
        canRedirectToInstantProfile,
      },
      setHasDeviceRemembered,
    } = this.props;
    const isCrossBorderPayments = shouldRedirectToInstantProfile(canRedirectToInstantProfile) && getUserProducts({ products: response?.reauth?.products, type: AEXP_CROSS_BORDER_PAYMENTS });
    const eidParam = getEidParam();
    eidParam.isCrossBorderPayments = isCrossBorderPayments;
    sessionStorage.setItem('eidParam', JSON.stringify(eidParam));

    let mfaIdQuery;
    let assessmentTokenQuery;
    let finalDestinationUrl = destinationFromState.url;

    if (response.errorCode === 'LGON009' || response.errorCode === 'LGON013') {
      const { reauth: { mfaId, assessmentToken } } = response;
      mfaIdQuery = mfaId;
      assessmentTokenQuery = assessmentToken;

      if (isCrossBorderPayments) {
        finalDestinationUrl = `/${cookieLocale}/account/profile/make?target=${destinationFromState.url}`;
      }

      updateAuth({
        loginUrl: `${pathname}${search}`,
        destination: finalDestinationUrl,
        eventDispatch: dispatch,
      });
    }
    const { dateOfLastPasswordChange } = response;
    const { deviceRemembered } = response?.reauth || {};
    // Set deviceRemembered value returned from the login api call
    // deviceRemembered can be boolean or string, true/false, or not set at all
    if (deviceRemembered === true || deviceRemembered === 'true') {
      setHasDeviceRemembered();
    }

    let url;
    switch (response.errorCode) {
      case 'LGON009':
        if (window.AmexSession) {
          window.AmexSession.start();
        }
        url = `/${cookieLocale}/account/reauth/verify?mfaId=${mfaIdQuery}`;
        break;
      case 'LGON013':
        if (window.AmexSession) {
          window.AmexSession.start();
        }
        url = `/${cookieLocale}/account/two-step-verification/verify?mfaId=${mfaIdQuery}&state=${assessmentTokenQuery}`;
        break;
      case 'LGON016':
        url = `/es-mx/account/${pathname.split('/account/')[1]}`;
        break;
      default:
        noOp(); // it's testable
        break;
    }
    if (url) {
      this.legacyPasswordRouting(
        dateOfLastPasswordChange,
        url,
        response
      );
    }
  };

  failureChangePassword = (url, errorCode, cookieLocale) => {
    const {
      setAppLocation,
      languageData,
      dispatch,
    } = this.props;

    eventArray.push({
      eventType: LOGIN_EVENT_FAILURE,
      errorCode,
      timestamp: Date.now() - loginStartTime,
    });
    dispatch(reportError(new Error(EVENT_ARRAY_FAILURE_LOG), {
      collectionMethod: 'failureRevoked',
      moduleID: 'one-identity-login',
      errorCode,
      eventArray,
    }));
    eventArray = [];

    if (this.isAtWork()) {
      let urlQuery = '';
      if (!languageData.links.forceChangePassword.includes('sso')) {
        urlQuery = `?target=${url}`;
      }
      return window.location.assign(`${languageData.links.forceChangePassword}${urlQuery}`);
    }

    return setAppLocation(`/${cookieLocale.toLowerCase()}/account/password/change?DestPage=${url}`);
  }

  internalErrorHandler = (response, url, startTime) => {
    const { errorCode, redirectUrl } = response;
    const {
      dispatch, pathname, locale,
    } = this.props;
    const { uuid } = this.state;
    const inAuth = `LOGIN-${uuid}`;
    const reportable = ['LGON010', 'LGON017', 'LGON018'];

    const cookieLocale = getLocaleFromCookie(locale);

    if (window.AmexSession) {
      window.AmexSession.options({
        locale: cookieLocale,
      });
    }

    const nonRedirectErrorCodes = [
      LOGIN_RESPONSE_LGON001,
      LOGIN_RESPONSE_LGON003,
      LOGIN_RESPONSE_LGON005,
      LOGIN_RESPONSE_LGON006,
      LOGIN_RESPONSE_LGON010,
      LOGIN_RESPONSE_LGON012,
      LOGIN_RESPONSE_LGON014,
      LOGIN_RESPONSE_LGON018,
      LOGIN_RESPONSE_LGON020,
    ];
    const roundTripResponseTime = Date.now() - startTime;

    TEMPLATES_IN_USE.forEach((template) => {
      if (pathname?.indexOf(template) >= 0) {
        dispatch(reportError(new Error(`${template.toUpperCase()} Failure`), {
          collectionMethod: 'mycaLogin',
          moduleID: 'one-identity-login',
          roundTripResponseTime,
          errorCode,
        }));
      }
    });

    if (errorCode === LOGIN_RESPONSE_LGON018) {
      this.setState({
        rockstarModal: true,
      });
    }

    if (nonRedirectErrorCodes.includes(errorCode)) {
      this.setState({
        submitReady: false,
        loading: false,
      });
    }

    if (response instanceof Error) {
      this.setState({
        submitReady: false,
      });
      return;
    }
    if (reportable.includes(errorCode)) {
      dispatch(reportError(new Error('Login API returned an errorCode'), {
        collectionMethod: 'mycaLogin',
        moduleID: 'one-identity-login',
        inauthProfileTransactionId: inAuth,
        errorCode,
      }));
    }

    switch (errorCode) {
      case LOGIN_RESPONSE_LGON004:
        this.failureRevoked(url, errorCode);
        break;
      case LOGIN_RESPONSE_LGON008:
        this.failureLegacyReAuth(redirectUrl, url, errorCode);
        break;
      case LOGIN_RESPONSE_LGON007:
      case LOGIN_RESPONSE_LGON011:
      case LOGIN_RESPONSE_LGON017:
        this.failureReLogin(url);
        break;
      case LOGIN_RESPONSE_LGON009:
      case LOGIN_RESPONSE_LGON013:
      case LOGIN_RESPONSE_LGON016:
        this.failureReAuth(response, cookieLocale, redirectUrl);
        break;
      case LOGIN_RESPONSE_LGON015:
        this.failureChangePassword(url, errorCode, cookieLocale);
        break;
      default:
        break;
    }

    this.userMessage();
  };

  cancelModal = () => {
    this.setState({
      rockstarModal: false,
      submitReady: false,
      showRecaptchaError: false,
    });
  }

  closeModal = () => {
    this.setState({
      rockstarModal: false,
      showRecaptchaError: false,
    });
  }

  // eslint-disable-next-line consistent-return -- allowing consistent-return
  fetchVerifyRecaptcha = async (data) => {
    const {
      faasApiUrl, dispatch, isLogSuccess, correlationId, recaptchaSiteKey,
    } = this.props;
    const { userId } = this.state;
    try {
      const errorReporter = (error, otherData) => dispatch(
        reportError(error, {
          ...otherData,
          userId: this.getUserId() || userId,
          collectionMethod: 'fetchVerifyRecaptcha',
          siteKey: recaptchaSiteKey,
        })
      );

      // Reset showRecaptchaError state before making API request
      await this.setStateSync({
        showRecaptchaError: false,
      });

      const url = `${faasApiUrl}/ReadGoogleRecaptcha.v1`;

      const response = await fetchWithReporter(
        url,
        {
          headers: {
            [CONTENT_TYPE]: CONTENT_TYPE_JSON,
            [PARAM_CORRELATION_ID]: correlationId,
          },
          [PARAM_CREDENTIALS]: CREDENTIALS_INCLUDE,
          [PARAM_METHOD]: METHOD_POST,
          [PARAM_BODY]: JSON.stringify(data),
          errorReporter,
          logSuccess: isLogSuccess,
        }
      );
      const respJSON = await response.json();

      // If recaptcha validation succeeded, call mycaLogin method and close modal
      if (respJSON.success) {
        await this.mycaLogin();
        return this.closeModal();
      }
      // If recaptcha validation failed, throw an error
      throw new Error('Google recaptcha could not validate on the server');
    } catch (err) {
      this.setState({
        showRecaptchaError: true,
      });
    }
  }

  verify = (recaptchaResponse) => {
    const { userId } = this.state;
    const data = {
      userAttribute: 'USERID',
      userAttributeValue: this.getUserId() || userId,
      recaptchaResponse,
    };

    return this.fetchVerifyRecaptcha(data);
  }

  menuIsDisplayed = () => {
    const {
      destPage,
      hideMenu,
      menu,
    } = this.props;
    const { destPageParam } = this.state;

    if (destPageParam) {
      return false;
    }

    if (destPage) {
      return false;
    }

    if (hideMenu) {
      return false;
    }

    return menu.length >= 2;
  };

  containsUppercase = (str) => Boolean(str.match(/[A-Z]/))

  isAtWork = () => {
    const destination = this.getDestination(this.props);
    return window.location.pathname.indexOf('at-work') >= 0
      || (this.dropMenu && this.getSelectedMenuItem().key === 'work')
      || (destination.key === 'work');
  }

  isMerchant = () => {
    const { query: { option } } = this.props;
    const destination = this.getDestination(this.props);
    return option === 'merchant' || (this.dropMenu && this.getSelectedMenuItem().key === 'merchant') || (destination.key === 'merchant');
  };

  isAbacus = () => {
    const { query: { option } } = this.props;
    return option === 'abacus';
  };

  isReconciliation = () => {
    const { query: { option } } = this.props;
    return option === 'reconciliation';
  };

  setLegacyPassword = (dateOfLastPasswordChange, targetUrl) => {
    const { flattenedPassword, migrationType } = this.state;
    const eidParam = getEidParam();
    eidParam.legacyPassword = this.migrationDateCheck(dateOfLastPasswordChange);
    eidParam.flattenedPassword = flattenedPassword;
    eidParam.target = targetUrl;
    eidParam.migrationType = migrationType;
    return sessionStorage.setItem('eidParam', JSON.stringify(eidParam));
  }

  setSuggestPasswordChange = (targetUrl) => {
    const eidParam = getEidParam();
    eidParam.suggestPasswordChange = true;
    eidParam.target = targetUrl;
    sessionStorage.setItem('eidParam', JSON.stringify(eidParam));
  }

  isAtWorkLocaleRedirect = () => {
    const { locale } = this.props;
    return localeRedirectMap[locale.toLowerCase()] && this.isAtWorkPasswordMigration();
  }

  migrationDateCheck = (dateOfLastPasswordChange) => {
    const {
      languageData: { passwordMigrationDate, merchantPasswordMigrationDate },
      query: { forcemigrationdate },
    } = this.props;

    return shouldPasswordMigrate(
      dateOfLastPasswordChange,
      this.isMerchantPasswordMigration()
        ? merchantPasswordMigrationDate
        : passwordMigrationDate,
      forcemigrationdate);
  }

  isAllowedErrorCode = (errorCode) => {
    const allowables = ['LGON013', 'LGON009'];
    return allowables.includes(errorCode);
  }

  routeLegacyPassword = (legacyPassword, errorCode) => {
    const {
      languageData: { passwordMigration },
      query: { forcemigrationdate },
    } = this.props;

    return legacyPassword
      && this.passwordMigration()
      && (passwordMigration || forcemigrationdate)
      && !this.isMerchantPasswordMigration()
      && !this.isAllowedErrorCode(errorCode);
  };

  routeLegacyPasswordMerchant = (legacyPassword, errorCode) => {
    const {
      languageData: { passwordMigration },
      query: { forcemigrationdate },
    } = this.props;

    return legacyPassword
      && this.passwordMigration()
      && (passwordMigration || forcemigrationdate)
      && this.isMerchantPasswordMigration()
      && !this.isAllowedErrorCode(errorCode);
  };

  legacyPasswordRouting = (dateOfLastPasswordChange, url, response) => {
    const {
      setAppLocation, locale, dispatch,
    } = this.props;
    const { flattenedPassword } = this.state;
    const legacyPassword = this.migrationDateCheck(dateOfLastPasswordChange);
    const suggestPasswordChange = response?.reauth?.passwordChangeRequired;

    let loginDestinationUrl;
    if (this.routeLegacyPassword(legacyPassword, response?.errorCode)) {
      loginDestinationUrl = `/${this.isAtWorkLocaleRedirect()
        ? localeRedirectMap[locale.toLowerCase()]
        : locale.toLowerCase()}/account/password/manage`;
    } else if (this.routeLegacyPasswordMerchant(legacyPassword, response?.errorCode) || suggestPasswordChange) {
      loginDestinationUrl = `/${locale.toLowerCase()}/account/password/manage`;
    } else {
      loginDestinationUrl = url;
    }

    // Tells password module to suggest password change
    if (suggestPasswordChange) {
      this.setSuggestPasswordChange(url);
    }

    if (this.passwordMigration() && legacyPassword) {
      this.setLegacyPassword(dateOfLastPasswordChange, url);
    }
    eventArray.push({
      eventType: ROUTE_TO_DESTINATION,
      url: loginDestinationUrl,
      legacyPassword,
      flattenedPassword,
      timestamp: Date.now() - loginStartTime,
    });
    dispatch(reportError(new Error(EVENT_ARRAY_LOG), {
      collectionMethod: 'legacyPasswordRouting',
      moduleID: 'one-identity-login',
      destinationUrl: loginDestinationUrl,
      eventArray,
    }));
    eventArray = [];
    setAppLocation(loginDestinationUrl);
  }

  isAtWorkMigration = () => {
    const { languageData: { atWorkPasswordMigration } } = this.props;
    return atWorkPasswordMigration;
  }

  isAtWorkPasswordMigration = () => this.isAtWork() && this.isAtWorkMigration();

  isMerchantPasswordMigration = () => {
    const { languageData: { passwordMigration } } = this.props;
    return this.isMerchant() && passwordMigration;
  }

  passwordMigration = () => (this.isAtWorkPasswordMigration()
    || this.isMerchantPasswordMigration()
    || window.location.pathname.indexOf('enterprise') >= 0)
    && !window.location.href.includes('third-party');

  setMigrationType = () => {
    if (this.isMerchantPasswordMigration()) {
      this.setState({
        migrationType: MIGRATION_TYPE_MERCHANT,
      });
    }
    if (this.isAtWorkPasswordMigration()) {
      this.setState({
        migrationType: MIGRATION_TYPE_ATWORK,
      });
    }
  }

  mycaLogin = () => {
    const {
      destinationFromState,
      sessionLogin,
      dispatch,
      query,
      languageData: {
        showRecaptcha,
        passwordMigration,
        canRedirectToInstantProfile,
      },
      pathname,
      loginUsApiDomain,
      locale,
      agentBindingData,
    } = this.props;

    const {
      remember,
      uuid,
      userId,
      password,
      passwordAttempt,
      wasFirstAttemptLowerCase,
    } = this.state;

    const transactionId = `LOGIN-${uuid}`;
    let attemptPassword = this.getPassword() || password;
    if (passwordAttempt === 0) {
      this.setState({
        wasFirstAttemptLowerCase: !this.containsUppercase(attemptPassword),
      });
    }

    if (
      this.passwordMigration()
      && this.containsUppercase(attemptPassword)
      && passwordAttempt === 1
      && (passwordMigration || query.forcemigrationdate)
      && !wasFirstAttemptLowerCase
    ) {
      attemptPassword = attemptPassword.toLowerCase();
      this.setState({
        flattenedPassword: true,
      });
    }

    const apiUrl = `${loginUsApiDomain}/myca/logon/${getRegionFromLocale(locale)}/action/login`;

    const roundTripStart = Date.now();
    eventArray.push({
      eventType: LOGIN_INVOCATION,
      apiUrl,
      timestamp: Date.now() - loginStartTime,
    });

    this.setMigrationType();
    const challengeable = () => {
      if (query.rockstar === 'on') {
        return 'FORCED';
      }
      if (showRecaptcha || this.isAtWork()) {
        return 'ON';
      }
      return null;
    };

    // Get webcrypto data from agent binding provider
    const { encryptedData, signature, publicKey } = agentBindingData;

    return sessionLogin({
      userId: this.getUserId() || userId,
      password: attemptPassword,
      remember,
      transactionId,
      destination: qualifyUrl(destinationFromState.url),
      channel: this.channel,
      challengeable: challengeable(),
      encryptedData,
      signature,
      publicKey,
    })
      .then((response) => {
        eventArray.push({
          eventType: LOGIN_RESPONSE_RECEIVED,
          apiUrl,
          responseCode: 'Success',
          timestamp: Date.now() - loginStartTime,
        });
        const roundTripResponseTime = Date.now() - roundTripStart;
        const { promise } = dispatch(queryProcedureResult({
          procedureName: 'readUserSession',
          args: {},
        }));

        return promise
          .catch((error) => dispatch(reportError(error, {
            collectionMethod: 'mycaLoginReadUserSession',
            userId: this.getUserId() || userId,
            moduleID: 'one-identity-login',
            roundTripResponseTime,
            inauthProfileTransactionId: transactionId,
          })))
          .then(() => {
            if (this.isAtWork()) {
              dispatch(reportError(new Error('At-Work Success'), {
                collectionMethod: 'mycaLogin',
                moduleID: 'one-identity-login',
                roundTripResponseTime,
                statusCode: response.statusCode,
                userId: this.getUserId() || userId,
              }));
            }

            if (this.isMerchant()) {
              dispatch(reportError(new Error('DMX Success'), {
                collectionMethod: 'mycaLogin',
                moduleID: 'one-identity-login',
                roundTripResponseTime,
                statusCode: response.statusCode,
              }));
            }

            if (this.isAbacus()) {
              dispatch(reportError(new Error('Abacus Success'), {
                collectionMethod: 'mycaLogin',
                moduleID: 'one-identity-login',
                roundTripResponseTime,
                statusCode: response.statusCode,
              }));
            }

            if (this.isReconciliation()) {
              dispatch(reportError(new Error('Reconciliation Success'), {
                collectionMethod: 'mycaLogin',
                moduleID: 'one-identity-login',
                roundTripResponseTime,
                statusCode: response.statusCode,
              }));
            }

            // Logs for any templates currently in use
            TEMPLATES_IN_USE.forEach((template) => {
              if (pathname?.indexOf(template) >= 0) {
                dispatch(reportError(new Error(`${template.toUpperCase()} Success`), {
                  collectionMethod: 'mycaLogin',
                  moduleID: 'one-identity-login',
                  roundTripResponseTime,
                  statusCode: response.statusCode,
                }));
              }
            });
            const cookieLocale = getLocaleFromCookie(locale);
            const isCrossBorderPayments = shouldRedirectToInstantProfile(canRedirectToInstantProfile) && getUserProducts({ products: response?.reauth?.products, type: AEXP_CROSS_BORDER_PAYMENTS });
            const eidParam = getEidParam();
            eidParam.isCrossBorderPayments = isCrossBorderPayments;
            sessionStorage.setItem('eidParam', JSON.stringify(eidParam));

            onLoginSuccess({
              response,
              url: isCrossBorderPayments ? `/${cookieLocale}/account/profile/make?target=${destinationFromState.url}` : destinationFromState.url,
              locale,
              cookieLocale,
              legacyPasswordRouting: this.legacyPasswordRouting,
            }, this.props);
          });
      })
      .catch((response) => {
        // ERROR ON CATCH
        const roundTripResponseTime = Date.now() - roundTripStart;
        if (this.isAtWork()) {
          dispatch(reportError(new Error('At-Work Failure'), {
            collectionMethod: 'mycaLogin',
            moduleID: 'one-identity-login',
            userId: this.getUserId() || userId,
            roundTripResponseTime,
            errorCode: response.errorCode,
          }));
        }

        if (this.isMerchant()) {
          dispatch(reportError(new Error('DMX Failure'), {
            collectionMethod: 'mycaLogin',
            moduleID: 'one-identity-login',
            roundTripResponseTime,
            errorCode: response.errorCode,
          }));
        }

        if (this.isAbacus()) {
          dispatch(reportError(new Error('Abacus Failure'), {
            collectionMethod: 'mycaLogin',
            moduleID: 'one-identity-login',
            roundTripResponseTime,
            errorCode: response.errorCode,
          }));
        }

        if (this.isReconciliation()) {
          dispatch(reportError(new Error('Reconciliation Failure'), {
            collectionMethod: 'mycaLogin',
            moduleID: 'one-identity-login',
            roundTripResponseTime,
            errorCode: response.errorCode,
          }));
        }

        eventArray.push({
          eventType: LOGIN_RESPONSE_RECEIVED,
          apiUrl,
          responseCode: response.errorCode,
          timestamp: Date.now() - loginStartTime,
        });
        const allowedErrorCodes = [
          LOGIN_RESPONSE_LGON009,
          LOGIN_RESPONSE_LGON015,
          LOGIN_RESPONSE_LGON013,
          LOGIN_RESPONSE_LGON018,
        ];
        if ((passwordMigration || query.forcemigrationdate) && this.passwordMigration()) {
          if (
            (passwordAttempt < 1
              && !this.containsUppercase(attemptPassword))
            || allowedErrorCodes.includes(response.errorCode)
            || passwordAttempt >= 1
          ) {
            if (response.errorCode !== LOGIN_RESPONSE_LGON018) {
              this.setState({
                passwordAttempt: passwordAttempt + 1,
              });
            }

            return this.onFailure(response, destinationFromState.url, roundTripStart);
          }
          this.setState({
            passwordAttempt: passwordAttempt + 1,
          });
          return this.mycaLogin();
        }

        this.setState({
          passwordAttempt: passwordAttempt + 1,
        });

        return this.onFailure(response, destinationFromState.url, roundTripStart);
      })
      .finally(() => {
        setLocalStorageCookie(destinationFromState.key || destinationFromState.overrideKey);
      });
  };

  ssoLogin = () => {
    const { destinationFromState, ssoLogin } = this.props;
    const { remember, userId, password } = this.state;

    ssoLogin(
      this.getUserId() || userId,
      this.getPassword() || password,
      destinationFromState.brandname,
      remember,
      destinationFromState.url,
      // the resultant code would not be nearly as consice
      // eslint-disable-next-line react/destructuring-assignment -- allowing destructuring-assignment
      this.props[`ssoLogin${destinationFromState.sso}`]
    );
  };

  changeRemember = (event) => {
    this.setState({ remember: event.target.checked });
  };

  updateDestination = () => {
    // TODO: check when dropRef is call for updateDestination ????
    const { step } = this.state;
    const { changeDestination, type } = this.props;
    const destination = this.getDestination(this.props);
    const eidParam = getEidParam();
    eidParam.accountType = destination.key || destination.overrideKey;
    sessionStorage.setItem('eidParam', JSON.stringify(eidParam));
    // Do not update destination if we're on password page of multipage
    if (
      (type === TYPE_MUTLIPAGE && step === STEP_ENTER_USERNAME)
      || type !== TYPE_MUTLIPAGE) {
      changeDestination(destination);
    }
  };

  dropRef = (el) => {
    this.dropMenu = el;
    this.updateDestination();
  };

  warningMessage = (message) => ({
    type: MESSAGE_WARNING,
    text: message,
  })

  userError = (errorCode) => {
    const { languageData, dispatch } = this.props;
    const messages = {
      [LOGIN_RESPONSE_LGON001]: this.warningMessage(languageData.status[LOGIN_RESPONSE_LGON001]),
      [LOGIN_RESPONSE_LGON005]: this.warningMessage(languageData.status[LOGIN_RESPONSE_LGON005]),
      [LOGIN_RESPONSE_LGON006]: this.warningMessage(
        languageData.status[LOGIN_RESPONSE_LGON006] || languageData.status[LOGIN_RESPONSE_LGON010]),
      [LOGIN_RESPONSE_LGON004]: null,
      [LOGIN_RESPONSE_LGON007]: null,
      [LOGIN_RESPONSE_LGON008]: null,
      [LOGIN_RESPONSE_LGON009]: null,
      [LOGIN_RESPONSE_LGON011]: null,
      [LOGIN_RESPONSE_LGON013]: null,
      [LOGIN_RESPONSE_LGON015]: null,
      [LOGIN_RESPONSE_LGON016]: null,
      [LOGIN_RESPONSE_LGON017]: null,
      [LOGIN_RESPONSE_LGON018]: null,
      [LOGIN_RESPONSE_LGON010]: this.warningMessage(languageData.status[LOGIN_RESPONSE_LGON010]),
      [LOGIN_RESPONSE_LGON012]: this.warningMessage(languageData.status[LOGIN_RESPONSE_LGON010]),
      [LOGIN_RESPONSE_LGON014]: this.warningMessage(languageData.status[LOGIN_RESPONSE_LGON010]),
      [LOGIN_RESPONSE_LGON020]: this.warningMessage(languageData.status[LOGIN_RESPONSE_LGON020]),
    };
    if (!Object.prototype.hasOwnProperty.call(messages, errorCode)) {
      eventArray.push({
        eventType: LOGIN_EVENT_FAILURE,
        errorCode,
        timestamp: Date.now() - loginStartTime,
      });
      dispatch(reportError(new Error(EVENT_ARRAY_FAILURE_LOG), {
        collectionMethod: 'userError',
        moduleID: 'one-identity-login',
        errorCode,
        eventArray,
      }));
      eventArray = [];
      return this.warningMessage(languageData.status[LOGIN_RESPONSE_LGON001]);
    }
    eventArray.push({
      eventType: LOGIN_EVENT_FAILURE,
      errorCode,
      timestamp: Date.now() - loginStartTime,
    });
    dispatch(reportError(new Error(EVENT_ARRAY_FAILURE_LOG), {
      collectionMethod: 'userError',
      moduleID: 'one-identity-login',
      errorCode,
      eventArray,
    }));
    eventArray = [];
    return messages[errorCode];
  };

  userMessage = () => {
    const { missing } = this.state;
    const {
      loginProgress,
      statusCode,
      errorCode,
      languageData,
      showSuccess,
    } = this.props;

    if (loginProgress) {
      return this.setState({
        message: null,
      });
    }

    if (missing) {
      return this.setState({
        message: {
          type: MESSAGE_WARNING,
          text: languageData.status.MISSING,
        },
      });
    }

    if (statusCode === 2) {
      return this.setState({
        message: null,
      });
    }

    if (statusCode === 0) {
      if (showSuccess) {
        return this.setState({
          message: {
            type: MESSAGE_POSITIVE,
            text: languageData.status[LOGIN_RESPONSE_SUCCESS],
          },
        });
      }
      return this.setState({
        message: null,
      });
    }

    return this.setState({
      message: this.userError(errorCode, languageData),
    });
  };

  userIdRef = (c) => {
    const { userIdRef } = this.props;
    this.inputUser = c;
    userIdRef(c);
  };

  passwordRef = (c) => {
    const { passwordRef } = this.props;
    this.inputPassword = c;
    passwordRef(c);
  };

  loadThirdPartyScripts() {
    const { inauthScriptDomain } = this.props;
    const { uuid } = this.state;

    const transactionId = `LOGIN-${uuid}`;
    const scriptInAuth = document.createElement('script');
    scriptInAuth.src = `${inauthScriptDomain}/cc.js?&sid=ee490b8fb9a4d570&tid=${transactionId}&namespace=inauth`;
    scriptInAuth.async = true;
    document.body.appendChild(scriptInAuth);

    const inauth = window.inauth = window.inauth || {};
    // clear the _cc object in case we are coming from another page
    inauth._cc = [];
    inauth._cc.push(['ci', { sid: 'ee490b8fb9a4d570', tid: transactionId }]);
    inauth._cc.push(['st', 500]);
    inauth._cc.push(['cf', 135732211]);
    inauth._cc.push(['run', inauthScriptDomain]);

    setTimeout(async () => {
      await this.setStateSync({
        authReady: true,
      });
      this.submitCheck();
    }, AUTH_READY_TIMEOUT);
  }

  // eslint-disable-next-line complexity -- allowing next line complexity
  render() {
    const {
      children,
      disableUserId,
      languageData,
      hideLinks,
      menu,
      loginProgress,
      parentClass,
      onClickSecLinks,
      links,
      location,
      destinationFromState,
      moduleLoadStatus,
      hideUserId,
      hidePassword,
      hideRemember,
      hideLoginButton,
      userIdLabel,
      passwordLabel,
      rememberLabel,
      loginLabel,
      alignLinks,
      type,
      locale,
      recaptchaSiteKey,
      moduleState,
      changeUserProfile,
      showOAuthPageRecoverCredentialsText,
    } = this.props;

    const {
      disableSubmit,
      remember,
      password,
      submitReady,
      framed,
      hideMultiPagePassword,
      hideMultiPageUserId,
      step,
      maskedName,
      rockstarModal,
      showRecaptchaError,
      message,
      loading,
    } = this.state;

    let loginButtonLabel = loginLabel || languageData.logIn;
    let multiPageGreeting;
    let multiPagePassword;

    const showVirtualKeyboard = languageData.showVirtualKeyboard && !isMobile();

    if (
      moduleLoadStatus === 'loading'
      || !languageData
      || Object.keys(languageData).length === 0) {
      return null;
    }

    // presence of destPage parameter in url overrides the showing of the menu
    const showMenu = this.menuIsDisplayed();

    if (type === TYPE_MUTLIPAGE) {
      const { continueLabel, passwordCopy, greeting } = languageData.multipage;
      multiPageGreeting = greeting;
      multiPagePassword = passwordCopy;
      if (step === STEP_ENTER_USERNAME) {
        loginButtonLabel = continueLabel;
      }
    }

    return (
      <div
        data-testid="one-identity-login"
        data-module-name="one-identity-login"
        className={parentClass}
      >
        {message
          && (
            <>
              <LoginMessage type={message.type}>{message.text}</LoginMessage>
              <hr className="margin-0" />
            </>
          )}
        <div className="eliloMain pad-responsive">
          <form method="POST" className="stack" onSubmit={this.loginFlowDecider}>
            <UserIdInput
              userId={this.getUserId()}
              moduleState={moduleState}
              inputLabel={userIdLabel || languageData.userId}
              userRef={this.userIdRef}
              disable={disableUserId ? 'disabled' : undefined}
              hideMultiPageUserId={hideMultiPageUserId}
              hideUserId={hideUserId}
              type={type}
            />
            <MultiPageGreeting
              type={type}
              maskedName={maskedName}
              multiPageGreeting={multiPageGreeting}
              multiPagePassword={multiPagePassword}
              step={step}
            />

            <PasswordInputWrapper
              passwordLabel={passwordLabel || languageData.password}
              defaultValue={password}
              hideMultiPagePassword={hideMultiPagePassword}
              hidePassword={hidePassword}
              passwordRef={this.passwordRef}
              showVirtualKeyboard={showVirtualKeyboard}
              onSubmit={this.loginFlowDecider}
              type={type}
              languageData={languageData}
            />
            {((type === TYPE_MUTLIPAGE && step === STEP_ENTER_USERNAME && showMenu)
              || (showMenu && type !== TYPE_MUTLIPAGE))
              && (
                <MenuDropDown
                  menu={menu}
                  updateDestination={this.updateDestination}
                  changeUserProfile={changeUserProfile}
                  dropRef={this.dropRef}
                  selectLabel={languageData.accountType}
                  moduleState={moduleState}
                  isDisabled={loading}
                />
              )}
            {(locale === 'es-MX' ? false : !hideRemember)
              && (
                <RememberMe
                  rememberLabel={rememberLabel || languageData.rememberMe}
                  isRemembered={remember}
                  changeRemember={this.changeRemember}
                  moduleState={moduleState}
                />
              )}
            {!hideLoginButton
              && (
                <ButtonPrimary
                  id="loginSubmit"
                  data-testid="submit-button"
                  type={loginProgress || submitReady ? 'button' : 'submit'}
                  className="fluid margin-0-b"
                  aria-busy={loading}
                  aria-label={loading ? `${loginButtonLabel} loading` : loginButtonLabel}
                  ref={this.submitButtonRef}
                  loading={loading}
                  disabled={disableSubmit}
                  aria-disabled={loading || disableSubmit}
                  reactlytics={{
                    element: submitReady || loginProgress ? 'Login_LogInButtonLoading' : 'Login_LogInButton',
                  }}
                >
                  {loginButtonLabel}
                </ButtonPrimary>
              )}
            {framed
              && (
                <ButtonSecondary
                  id="cancel-framed"
                  data-testid="cancel-framed-button"
                  reactlytics={{
                    element: 'Login_CancelFramed',
                  }}
                  onClick={() => {
                    window.top.postMessage({
                      messageId: 'LOGIN',
                      status: 'Canceled',
                    }, '*');
                  }}
                  type="button"
                  className="fluid margin-0-b margin-1-t"
                  disabled={disableSubmit}
                >
                  {languageData.cancel}
                </ButtonSecondary>
              )}
          </form>

          {!hideLinks
            && (
              <LoginLinks
                links={links}
                onClickSecLinks={onClickSecLinks}
                destination={destinationFromState}
                location={location}
                align={alignLinks}
              />
            )}

          {showOAuthPageRecoverCredentialsText && languageData?.OAuthPageRecoverCredentialsText && (
            <h1 className="body-1 margin-2-t">{languageData?.OAuthPageRecoverCredentialsText}</h1>
          )}

          {children}
        </div>
        {rockstarModal
          && (
            <Recaptcha
              locale={locale}
              errorMessage={languageData.status.LGON010}
              showRecaptchaError={showRecaptchaError}
              cancelModal={this.cancelModal}
              verify={this.verify}
              recaptchaSiteKey={recaptchaSiteKey}
            />
          )}
      </div>
    );
  }
}

LoginUI.propTypes = {
  noOp: func,
  children: node,
  destPage: string.isRequired,
  sso: string,
  brandname: string,
  disableUserId: bool,
  hideLinks: bool,
  hideLoginLogoutButton: func.isRequired,
  hideMenu: bool,
  loginProgress: bool.isRequired,
  links: arrayOf(shape({})).isRequired,
  locale: string.isRequired,
  languageData: shape({
    links: shape({
      menu: arrayOf(shape({
        key: string.isRequired,
        url: string.isRequired,
        sso: string,
        brandname: string,
      })),
      secondary: arrayOf(shape({})),
    }),
  }).isRequired,
  menu: arrayOf(shape({
    key: string.isRequired,
    url: string.isRequired,
    label: string.isRequired,
    sso: string,
    brandname: string,
  })).isRequired,
  moduleLoadStatus: oneOf(['loading', 'loaded', 'error']),
  onFailure: func, // TODO: check onFailure,
  failureCodes: arrayOf(string), // TODO: check faiulureCodes
  onClickSecLinks: func, // TODO check onClickSecLinks
  parentClass: string,
  password: string,
  passwordRef: func,
  sessionLogin: func.isRequired,
  getUserNameByUserId: func.isRequired,
  setAppLocation: func.isRequired,
  showLoginLogoutButton: func.isRequired,
  showSuccess: bool,
  ssoLogin: func.isRequired,
  legacyLogin: func.isRequired,
  query: shape({}).isRequired,
  status: shape({
    statusCode: number,
    errorCode: string,
  }).isRequired,
  userId: string,
  userIdRef: func,
  clearStatus: func,
  location: shape({
    host: string,
    protocol: string,
  }).isRequired,
  changeDestination: func.isRequired,
  shouldFocus: bool,
  inauthScriptDomain: string.isRequired,
  loginUsApiDomain: string.isRequired,
  destinationFromState: shape({
    url: string,
  }).isRequired,
  search: string.isRequired,
  pathname: string.isRequired,
  updateAuth: func.isRequired,
  statusCode: number.isRequired,
  errorCode: string.isRequired,
  effectiveKey: string.isRequired,
  dispatch: func.isRequired,
  hideUserId: bool,
  hidePassword: bool,
  hideRemember: bool,
  hideLoginButton: bool,
  userIdLabel: string,
  passwordLabel: string,
  rememberLabel: string,
  loginLabel: string,
  alignLinks: string,
  setLocation: func.isRequired,
  setContext: func.isRequired,
  type: string.isRequired,
  faasApiUrl: string.isRequired,
  isLogSuccess: bool,
  correlationId: string,
  recaptchaSiteKey: string,
  changeUserProfile: func,
  moduleState: shape({}),
  agentBindingData: shape({
    isReady: bool,
    encryptedData: string,
    signature: string,
    publicKey: string,
  }),
  setHasDeviceRemembered: func,
  showOAuthPageRecoverCredentialsText: bool,
};

LoginUI.contextTypes = {
  size: string,
  agentBindingData: shape({
    isReady: bool,
    encryptedData: string,
    signature: string,
    publicKey: string,
  }),
};

LoginUI.defaultProps = {
  children: null,
  clearStatus: noop,
  disableUserId: false,
  failureCodes: null,
  hideLinks: false,
  hideMenu: false,
  parentClass: 'card pad-0-b dls-white-bg',
  passwordRef: noop,
  showSuccess: false,
  userIdRef: noop,
  sso: undefined,
  brandname: '',
  shouldFocus: true,
  noOp: noop,
  onFailure: null,
  onClickSecLinks: null,
  password: '',
  userId: '',
  hideUserId: false,
  hidePassword: false,
  hideRemember: false,
  hideLoginButton: false,
  userIdLabel: undefined,
  passwordLabel: undefined,
  rememberLabel: undefined,
  loginLabel: undefined,
  alignLinks: 'left',
  showOAuthPageRecoverCredentialsText: false,
};

export default LoginUI;

/* eslint-enable no-multi-assign -- enabling no-multi-assign */
/* eslint-enable no-underscore-dangle -- enabling no-underscore-dangle */
/* eslint-enable react/boolean-prop-naming -- enabling boolean-prop-naming */
